import { Button } from "./Button";
import { useFunnel } from "../../context/FunnelContext";
import { useFunnelNavigation } from "../../hooks/useFunnelNavigation";

export function NavigationBar() {
  const { state } = useFunnel();
  const { previousStep } = useFunnelNavigation();

  return (
    <div>
      <div className="flex items-center py-4">
        {/* Left section for back button */}
        <div className="w-10 md:w-12">
          <Button
            variant="secondary"
            onClick={previousStep}
            className={`!p-2 md:!p-3 ${
              state.currentStep <= 1 ? "invisible" : ""
            }`}
          >
            <img src={"/back_arrow.svg"} alt="Back" width="20" height="20" />
          </Button>
        </div>

        {/* Center section for logo and text */}
        <div className="flex-1 flex items-center justify-center gap-[8px] font-[500] text-[15px] leading-[22.5px] text-gray-800">
          <img src="/app_icon.png" alt="Caloria Logo" className="h-8 w-auto" />
          <span className="text-m font-medium text-gray-900">
            Calorie Counter
          </span>
        </div>

        {/* Right section for symmetry (empty) */}
        <div className="w-10 md:w-12"></div>
      </div>
    </div>
  );
}
